import { func, node, shape } from 'prop-types';
import React, { PureComponent } from 'react';
import { fetch } from 'reactor/components';
import { Consumer as ConsumerReactor, Provider as ProviderReactor } from 'reactor/context';

import { C, L10N, SHAPES } from 'common';
import { ConsumerData, ProviderData } from './contextData';
import { ConsumerEvents, ProviderEvents } from './contextEvents';

const { FETCH_PROPS, LANGUAGE } = C;

const Consumer = ({ children }) => (
  <ConsumerReactor>
    { consumer => (
      <ConsumerData>
        { data => (
          <ConsumerEvents>
            { events => children({ ...data, ...events, ...consumer })}
          </ConsumerEvents>
        )}
      </ConsumerData>
    )}
  </ConsumerReactor>
);

Consumer.propTypes = {
  children: func.isRequired,
};

class Provider extends PureComponent {
  static propTypes = {
    children: node.isRequired,
    session: shape(SHAPES.SESSION),
  };

  static defaultProps = {
    session: undefined,
  };

  state = {
    l10n: undefined,
    ready: false,
  };

  async componentWillMount() {
    const l10n = await fetch({
      ...FETCH_PROPS, service: `dictionary/cockpit/${LANGUAGE}`,
    }).catch(error => console.error('api/dictionary', error)); // @TODO: We should show the error

    this.setState({ l10n: { [LANGUAGE]: l10n }, ready: true });
  }

  render() {
    const {
      props: { children, session, ...events },
      state: { l10n = L10N, ready },
    } = this;

    return (
      <ProviderReactor dictionary={l10n} language={LANGUAGE}>
        <ProviderData>
          <ProviderEvents {...events}>
            { ready ? children : undefined}
          </ProviderEvents>
        </ProviderData>
      </ProviderReactor>
    );
  }
}

export {
  Consumer,
  Provider,
};
